import { FunctionComponent } from 'react'
import Header from '../../components/header/header.components'
import CategoriesOverview from '../../components/categories-overview/categories-overview.component'

const ExplorePage: FunctionComponent = () => {
  return (
    <>
      <Header />
      <CategoriesOverview />
    </>
  )
}

export default ExplorePage
